import { insertQueuedEmail } from "../../services/adminDocuments_service";
import { toast } from "react-toastify";

const QueueEmailModal = ({
  show,
  payload,
  onClose,
  reloadGrid
}) => {

  if (!show) return null;

  const handleConfirm = async () => {

    try {

      const response = await insertQueuedEmail(
        payload.docIds,
        payload.emailTemplateId,
        payload.userId,
        payload.documentTypeId,
        true
      );

      if (response.data >= 0) {

        toast.success("Email Queued Successfully.");

        if (reloadGrid) reloadGrid();

        onClose();

      }
      else if(response.data === -5){
        toast.error("Recipients not found. Email not queued.")
      }
      else if(response.data === -6){
        toast.error("No default template found for the document type. Email not queued")
      }
      else {

        toast.error("Some exception occurred while queueing email.");

      }

    }
    catch {

      toast.error("Unable to queue email.");

    }

  };

  return (
    <>

      <div className="modal fade in" style={{ display: "block" }}>

        <div className="modal-dialog" style={{ width: "600px" }}>

          <div className="modal-content">

            {/* HEADER */}

            <div className="modal-header" style={{ padding: "0px 0px" }}>

              <button
                type="button"
                className="close"
                onClick={onClose}
              >
                &times;
              </button>

              <h4 className="modal-title" style={{ margin: 0 }}>
                Do you want to Queue the Email?
              </h4>

            </div>

            {/* BODY */}

            <div
              className="modal-body"
              style={{
                paddingTop: "30px",
                paddingBottom: "85px"
              }}
            >

              Email will be sent to Queue. Are you sure?

            </div>

            {/* FOOTER */}

            <div className="modal-footer">

              <button
                className="btn btn-primary"
                onClick={handleConfirm}
              >
                Yes
              </button>

              <button
                className="btn btn-default"
                onClick={onClose}
              >
                Cancel
              </button>

            </div>

          </div>

        </div>

      </div>

    </>
  );
};

export default QueueEmailModal;